const KEY = 'bc_briefy_cfg';
const DEFAULTS = { interactive: true, idle: true, haptics: true, sound: false, animations: true };

export const getBriefyConfig = () => {
  try {
    return { ...DEFAULTS, ...(JSON.parse(localStorage.getItem(KEY)) || {}) };
  } catch {
    return { ...DEFAULTS };
  }
};

export const setBriefyConfig = (patch) => {
  const next = { ...getBriefyConfig(), ...patch };
  localStorage.setItem(KEY, JSON.stringify(next));
  window.dispatchEvent(new Event('briefy:config'));
  return next;
};
